export const dropdownStyles = {
  outline: 'none',
  display: 'flex',
  textTransform: 'none',
  justifyContent: 'flex-start !important',
  alignItems: 'center',
  background: 'transparent !important',
  padding: '0',
  '&:focus': {
    outline: 'none'
  }
}
